// source: inv_view_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var inv_common_message_pb = require('./inv_common_message_pb.js');
goog.object.extend(proto, inv_common_message_pb);
var inv_view_message_pb = require('./inv_view_message_pb.js');
goog.object.extend(proto, inv_view_message_pb);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.repeatedFields_, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.displayName = 'proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest.displayName = 'proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest.displayName = 'proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest.displayName = 'proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection.repeatedFields_, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection.displayName = 'proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse.displayName = 'proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userName: jspb.Message.getFieldWithDefault(msg, 1, ""),
userGroupsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest;
  return proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string user_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string user_groups = 2;
 * @return {!Array<string>}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.prototype.getUserGroupsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.prototype.setUserGroupsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.prototype.addUserGroups = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.GetViewsRequest.prototype.clearUserGroupsList = function() {
  return this.setUserGroupsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
view: (f = msg.getView()) && inv_view_message_pb.View.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest;
  return proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new inv_view_message_pb.View;
      reader.readMessage(value,inv_view_message_pb.View.deserializeBinaryFromReader);
      msg.setView(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getView();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      inv_view_message_pb.View.serializeBinaryToWriter
    );
  }
};


/**
 * optional View view = 1;
 * @return {?proto.Olameter.WFMS.InventoryManagement.View.v1.View}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest.prototype.getView = function() {
  return /** @type{?proto.Olameter.WFMS.InventoryManagement.View.v1.View} */ (
    jspb.Message.getWrapperField(this, inv_view_message_pb.View, 1));
};


/**
 * @param {?proto.Olameter.WFMS.InventoryManagement.View.v1.View|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest} returns this
*/
proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest.prototype.setView = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest.prototype.clearView = function() {
  return this.setView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.SaveViewRequest.prototype.hasView = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest;
  return proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.DeleteViewRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest;
  return proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.UpdateLastSeenViewRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection.toObject = function(includeInstance, msg) {
  var f, obj = {
viewsList: jspb.Message.toObjectList(msg.getViewsList(),
    inv_view_message_pb.View.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection;
  return proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new inv_view_message_pb.View;
      reader.readMessage(value,inv_view_message_pb.View.deserializeBinaryFromReader);
      msg.addViews(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getViewsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      inv_view_message_pb.View.serializeBinaryToWriter
    );
  }
};


/**
 * repeated View views = 1;
 * @return {!Array<!proto.Olameter.WFMS.InventoryManagement.View.v1.View>}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection.prototype.getViewsList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.InventoryManagement.View.v1.View>} */ (
    jspb.Message.getRepeatedWrapperField(this, inv_view_message_pb.View, 1));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.InventoryManagement.View.v1.View>} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection} returns this
*/
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection.prototype.setViewsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.View=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.View}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection.prototype.addViews = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Olameter.WFMS.InventoryManagement.View.v1.View, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponseCollection.prototype.clearViewsList = function() {
  return this.setViewsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
view: (f = msg.getView()) && inv_view_message_pb.View.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse;
  return proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new inv_view_message_pb.View;
      reader.readMessage(value,inv_view_message_pb.View.deserializeBinaryFromReader);
      msg.setView(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getView();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      inv_view_message_pb.View.serializeBinaryToWriter
    );
  }
};


/**
 * optional View view = 1;
 * @return {?proto.Olameter.WFMS.InventoryManagement.View.v1.View}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse.prototype.getView = function() {
  return /** @type{?proto.Olameter.WFMS.InventoryManagement.View.v1.View} */ (
    jspb.Message.getWrapperField(this, inv_view_message_pb.View, 1));
};


/**
 * @param {?proto.Olameter.WFMS.InventoryManagement.View.v1.View|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse} returns this
*/
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse.prototype.setView = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse.prototype.clearView = function() {
  return this.setView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.ViewResponse.prototype.hasView = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.Olameter.WFMS.InventoryManagement.View.v1);
